import { render } from "./sale.vue?vue&type=template&id=02f0bd6e&scoped=true"
import script from "./sale.vue?vue&type=script&lang=js"
export * from "./sale.vue?vue&type=script&lang=js"

import "./sale.vue?vue&type=style&index=0&id=02f0bd6e&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f0bd6e"]])

export default __exports__